export default __webpack_public_path__ + "static/media/jeff.8fced577.jpg";